"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackUserClick = void 0;
const browser_tracker_1 = require("@snowplow/browser-tracker");
/**
 * Track User-click event in Snowplow.
 * v.0.13.0;
 * @public
 *
 * @param eventData - Object that contains event properties described in the User Click Event document
 * (see https://healthcareinc.atlassian.net/l/cp/HNaWAs71 ).
 *
 * @example
 * ```ts
 *
 * import {trackUserClick} from '@hc-frontend/third-party-snowplow';
 *
 * trackUserClick({
 *   category: 'landing',
 *   placement: 'hero-section',
 *   action: 'submit',
 *   label: 'See Plans',
 *   value: '...',
 *   elementId: '...',
 *   targetUrl: '...',
 *   description: '...',
 * });
 * ```
 */
function trackUserClick(eventData, contexts) {
    const { category, placement, action, label, value, elementId, targetUrl, description, } = eventData;
    (0, browser_tracker_1.trackSelfDescribingEvent)({
        event: {
            schema: 'iglu:com.healthcare/user_click/jsonschema/1-0-3',
            data: {
                category,
                placement,
                action,
                label,
                value,
                element_id: elementId,
                target_url: targetUrl,
                description,
            },
        },
        context: contexts,
    });
}
exports.trackUserClick = trackUserClick;
//# sourceMappingURL=user-click.js.map